import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { BookOpen } from 'lucide-react';
import { muted, primary, card, store } from './mbApi';
import { GuideCard } from './GuideCard';

export const GuideDrawer = ({ open, setOpen, canManage }) => (
  <Sheet open={open} onOpenChange={setOpen}>
    <SheetContent side="right" className="mb-scope w-full sm:max-w-2xl overflow-y-auto" data-testid="mb-guide-drawer">
      <SheetHeader className="text-left"><SheetTitle className={primary}>Cara Guna Marketing Hub</SheetTitle></SheetHeader>
      <GuideCard canManage={canManage} embedded />
    </SheetContent>
  </Sheet>
);

export const GuideButton = ({ onClick }) => (
  <Button variant="outline" className="h-10" onClick={onClick} data-testid="mb-guide-open">
    <BookOpen size={16} className="mr-1.5 text-[#F77F00]" /> Panduan
  </Button>
);

export const Onboarding = ({ onOpenGuide }) => {
  const [hide, setHide] = useState(() => store.get('mb-onboarded') === '1');
  if (hide) return null;
  const close = () => { store.set('mb-onboarded', '1'); setHide(true); };
  return (
    <div className={`${card} space-y-2`} data-testid="mb-onboarding">
      <p className={`text-sm font-semibold ${primary}`}>Mula di sini — siapa buat apa</p>
      <ul className={`text-sm ${muted} space-y-1 list-disc pl-5`}>
        <li><span className={primary}>Kaer</span>: Buat Brief (borang atau PDF) → serah ke Bahan.</li>
        <li><span className={primary}>Firzan</span>: tambah versi bahan → review Lulus → serah ke Ujian.</li>
        <li><span className={primary}>Azrai</span>: Ujian Baru → invite → salin URL Iklan → buat iklan di Meta → padan Ad ID → pantau.</li>
      </ul>
      <p className={`text-sm ${muted}`}>Tab <span className={primary}>Tugasan Saya</span> tunjuk apa perlu dibuat sekarang. Tekan butang pada kad untuk terus ke tempat kerja.</p>
      <div className="flex flex-wrap gap-2">
        <Button variant="outline" className="h-10" onClick={onOpenGuide} data-testid="mb-onboarding-guide">Buka panduan penuh</Button>
        <Button className="h-10" onClick={close} data-testid="mb-onboarding-dismiss">Faham, tutup</Button>
      </div>
    </div>
  );
};
